<template>
  <div class="fan fan-component f-plugin-calendar">
    <f-layout ref="flayout"
              :superApi="superApi"
              @reloadData="reloadData">

      <!-- 主体 -->
      <template #body>
        <!-- 顶部操作栏 -->
        <div class="calendar-toolbar">
          <div class="toolbar-left">
            <a-button-group>
              <a-button @click="prevMonth"><icon-left /></a-button>
              <a-button @click="toToday"><icon-calendar-clock /></a-button>
              <a-button @click="nextMonth"><icon-right /></a-button>
            </a-button-group>
            <span class="current-month">{{ currentYear }}年 {{ currentMonth }}月</span>
          </div>
          <div class="toolbar-right">
            <a-button type="primary" @click="handleAdd(selectedDateStr)"><icon-plus /> 新建</a-button>
          </div>
        </div>

        <!-- 日历表格 -->
        <a-spin :loading="loading" tip="加载中...">
          <div class="calendar-grid">
            <div class="weekday-header">
              <div v-for="day in weekDays" :key="day" class="weekday-cell">{{ day }}</div>
            </div>
            <div class="calendar-body">
              <div
                v-for="(cell, idx) in calendarCells"
                :key="idx"
                class="day-cell"
                :class="{
                  'is-today': cell.isToday,
                  'is-other-month': !cell.isCurrentMonth,
                  'has-events': cell.events.length > 0
                }"
                @click="handleDayClick(cell)"
              >
                <div class="day-num">{{ cell.day }}</div>
                <div class="day-events" v-if="cell.events.length > 0">
                  <a-tag
                    v-for="evt in cell.events.slice(0, 3)"
                    :key="evt.id"
                    :color="evt.color || 'blue'"
                    size="small"
                  >{{ getDisplayVal(evt) }}</a-tag>
                  <span v-if="cell.events.length > 3" class="more-tag">+{{ cell.events.length - 3 }}</span>
                </div>
              </div>
            </div>
          </div>
        </a-spin>

        <!-- 选中日期的日程列表 -->
        <div class="day-detail" v-if="selectedDateStr">
          <a-divider />
          <div class="detail-header">
            <span class="detail-date">{{ selectedDateStr }} 日程</span>
            <a-button type="text" size="small" @click="handleAdd(selectedDateStr)"><icon-plus /> 添加</a-button>
          </div>
          <f-table
            v-if="selectedEvents.length > 0"
            :superData="{ data: selectedEvents, total: selectedEvents.length }"
            :superColumns="superColumns"
            :superFilter="{}"
            :superLoading="false"
          >
            <template #action="{ record }">
              <a-button-group class="action-btn-group">
                <!-- 编辑 -->
              <a-tooltip content="编辑">
                <div class="action-btn" @click="handleEdit(record)">
                  <icon-edit />
                </div>
              </a-tooltip>

              <!-- 删除 -->
              <a-popconfirm content="确定要删除这条记录吗？" @ok="handleDelete(record)">
                <a-tooltip content="删除">
                  <div class="action-btn delete-btn">
                    <icon-delete />
                  </div>
                </a-tooltip>
              </a-popconfirm>
                <!-- <a-button size="mini" type="text" @click="handleEdit(record)"><icon-edit /></a-button>
                <a-popconfirm content="确定删除？" @ok="handleDelete(record)">
                  <a-button size="mini" type="text" status="danger"><icon-delete /></a-button>
                </a-popconfirm> -->
              </a-button-group>
            </template>
          </f-table>
          <div v-else class="empty-tip">暂无日程</div>
        </div>
      </template>
    </f-layout>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'FPluginCalendar',
  props: {
    superTitle: { type: String, default: '' },
    superApi: { type: String, default: '' },
    superColumns: { type: Array, default: () => [] },
    queryField: { type: String, default: 'months' },
    dateField: { type: String, default: 'adddate' },
    displayField: { type: String, default: 'name' }
  },
  data() {
    return {
      loading: false,
      currentYear: moment().year(),
      currentMonth: moment().month() + 1,
      events: [],
      selectedDateStr: '',
      colorMap: {
        '会议': 'blue', '任务': 'green', '提醒': 'orange', '活动': 'purple', '其他': 'gray'
      }
    }
  },
  computed: {
    weekDays() { return ['日', '一', '二', '三', '四', '五', '六'] },
    calendarCells() {
      const startOfMonth = moment([this.currentYear, this.currentMonth - 1, 1])
      const startDay = startOfMonth.day()
      const daysInMonth = startOfMonth.daysInMonth()
      const todayStr = moment().format('YYYY-MM-DD')
      const cells = []
      const prevMonthDays = moment([this.currentYear, this.currentMonth - 1, 1]).subtract(1, 'day').daysInMonth()
      for (let i = startDay - 1; i >= 0; i--) {
        const d = prevMonthDays - i
        const ds = moment([this.currentYear, this.currentMonth - 2, d]).format('YYYY-MM-DD')
        cells.push({ day: d, date: ds, isCurrentMonth: false, isToday: ds === todayStr, events: this.getEvts(ds) })
      }
      for (let d = 1; d <= daysInMonth; d++) {
        const ds = moment([this.currentYear, this.currentMonth - 1, d]).format('YYYY-MM-DD')
        cells.push({ day: d, date: ds, isCurrentMonth: true, isToday: ds === todayStr, events: this.getEvts(ds) })
      }
      const rem = 42 - cells.length
      for (let d = 1; d <= rem; d++) {
        const ds = moment([this.currentYear, this.currentMonth, d]).format('YYYY-MM-DD')
        cells.push({ day: d, date: ds, isCurrentMonth: false, isToday: ds === todayStr, events: this.getEvts(ds) })
      }
      return cells
    },
    selectedEvents() {
      return this.selectedDateStr ? this.getEvts(this.selectedDateStr) : []
    }
  },
  async mounted() {
    await this.initPage()
  },
  async activated() {
    await this.initPage()
  },
  methods: {
    async initPage() {
      this.selectedDateStr = moment().format('YYYY-MM-DD')
      this.$store.state.page.columns = {}
      this.$store.state.page.tableColumns = []
      this.$store.state.page.keyinfo = {}
      if (this.superColumns.length > 0) {
        this.$fan.page.loadCallback(this.superColumns, {}).catch(() => {})
      }
      this.loadEvents()
    },
    moment,
    getDisplayVal(evt) {
      const val = evt[this.displayField]
      if (val === undefined || val === null) return ''
      const getName = (v) => {
        if (v === undefined || v === null) return null
        const keyinfo = this.$store.state.page?.keyinfo || {}
        const optMap = keyinfo[this.displayField]
        if (!optMap) return null
        const opt = optMap[v] || optMap[String(v)]
        return (opt && opt.name) || null
      }
      if (Array.isArray(val)) return val.map(v => getName(v) || v).join('、')
      return getName(val) || val
    },
    getEvts(dateStr) {
      return this.events.filter(e => e[this.dateField] === dateStr).map(e => ({
        ...e, color: e.color || this.colorMap[e.type] || 'blue'
      })).sort((a, b) => (a.time || '').localeCompare(b.time || ''))
    },
    prevMonth() {
      this.currentMonth === 1 ? (this.currentYear--, this.currentMonth = 12) : this.currentMonth--
      this.loadEvents()
    },
    nextMonth() {
      this.currentMonth === 12 ? (this.currentYear++, this.currentMonth = 1) : this.currentMonth++
      this.loadEvents()
    },
    toToday() {
      this.currentYear = moment().year()
      this.currentMonth = moment().month() + 1
      this.selectedDateStr = moment().format('YYYY-MM-DD')
      this.loadEvents()
    },
    handleDayClick(cell) {
      this.selectedDateStr = cell.date
    },
    async loadEvents() {
      if (!this.superApi) return
      this.loading = true
      try {
        const val = this.currentYear + '-' + String(this.currentMonth).padStart(2, '0')
        const query = {}
        query[this.queryField] = val
        const res = await this.$fan.api.get(this.superApi, query)
        if (res && res.status === 0) this.events = (res.data && res.data.data) ? res.data.data : []
      } catch {} finally { this.loading = false }
    },
    reloadData() {
      this.loadEvents()
    },
    handleAdd(dateStr) {
      const ds = dateStr || this.selectedDateStr || moment().format('YYYY-MM-DD')
      const record = {}
      record[this.dateField] = ds
      this.$refs.flayout.bindOpenCurd('新增', { record })
    },
    handleEdit(record) {
      this.$refs.flayout.bindOpenCurd('编辑', { record })
    },
    async handleDelete(record) {
      try {
        const res = await this.$fan.api.delete(this.superApi + '/' + record.id)
        if (res.status === 0) { this.$message.success('已删除'); await this.loadEvents() }
        else { this.$message.error('删除失败') }
      } catch { this.$message.error('删除失败') }
    }
  }
}
</script>

<style scoped lang="less">
.f-plugin-calendar {
  height: 100%;
  display: flex;
  flex-direction: column;
  :deep(.f-layout-content),
  :deep(.f-layout-level2),
  :deep(.main),
  :deep(.mainBody),
  :deep(.mainContent),
  :deep(.content),
  :deep(.contentBody) {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  :deep(.contentBody) > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}

.calendar-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-shrink: 0;
  .toolbar-left { display: flex; align-items: center; gap: 16px; }
  .current-month { font-size: 18px; font-weight: 600; color: #1d2129; }
}

.calendar-grid {
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.weekday-header {
  display: grid; grid-template-columns: repeat(7, 1fr);
  background: #f7f8fa; border-bottom: 1px solid #e5e6eb;
  flex-shrink: 0;
  .weekday-cell { text-align: center; padding: 10px 0; font-weight: 600; color: #4e5969; font-size: 13px; }
}
.calendar-body { display: grid; grid-template-columns: repeat(7, 1fr); flex: 1; }
.day-cell {
  padding: 6px;
  border-right: 1px solid #f0f1f3; border-bottom: 1px solid #f0f1f3;
  cursor: pointer; transition: background 0.15s;
  &:nth-child(7n) { border-right: none; }
  &:hover { background: #f2f7ff; }
  &.is-other-month .day-num { color: #c9cdd4; }
  &.is-today {
    background: #e8f3ff;
    .day-num { background: #165dff; color: #fff; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; }
  }
  .day-num { font-size: 14px; color: #1d2129; margin-bottom: 4px; padding: 2px 0; }
  .day-events { display: flex; flex-direction: column; gap: 2px; overflow: hidden;
    .arco-tag { font-size: 11px; line-height: 18px; }
    .more-tag { font-size: 11px; color: #86909c; padding-left: 4px; }
  }
}
.day-detail {
  flex-shrink: 0;
  .detail-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
  .detail-date { font-size: 16px; font-weight: 600; color: #1d2129; }
  .empty-tip { text-align: center; color: #c9cdd4; padding: 20px 0; }
}
.action-btn-group {
      display: inline-flex;
      align-items: center;
      border: 1px solid #e5e6eb;
      border-radius: 5px;
      overflow: hidden;
      .action-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        color: #4e5969;
        cursor: pointer;
        transition: all 0.2s;
        // 给按钮之间加分割线，模拟按钮组效果
        &:not(:last-child) {
          border-right: 1px solid #e5e6eb;
        }
        &:hover {
          color: #1677ff;
          background-color: #f2f3f5;
        }
      }
      .delete-btn {
        background-color: #f53f3f;
        color: #fff;
        &:hover {
          color: #fff;
          background-color: #f9695e;
        }
      }
      .other-btn {
        background-color: #186df6 !important;
        color: #fff !important;
        &:hover {
          color: #fff !important;
          background-color: #5185f5 !important;
        }
        .arco-icon {
          color: inherit !important;
        }
      }
    }
</style>
